var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg10D(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 5.99999,
    r: 2.22727,
    stroke: "#facc15"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 9.40909V11",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4091 6H21",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 2.59091V1",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6H12.5909",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 3.5L19.6364 2.13637",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.5L12.3636 2.13637",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8.5L19.6364 9.86364",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 8.5L12.3636 9.86364",
    stroke: "#facc15",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5 15H12H20.5C21.3333 15 23 14.5 23 12.5C23 11.6809 22.5169 10.0566 20.601 10.0014C20.5458 9.99985 20.5002 9.95453 20.4981 9.89934C20.4087 7.53774 17.1875 6.13164 15.1921 8.73133C15.1319 8.80982 14.9949 8.76871 14.9879 8.67002C14.8636 6.93062 13.7506 4 10 4C8.34755 4 5.05674 4.98301 5.00072 8.89831C4.99993 8.95353 4.95529 8.99984 4.9001 9.00192C3.87293 9.04062 2 9.6775 2 12C2 13 2.6 15 5 15Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16L4 22",
    stroke: "#0284C7",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L9 22",
    stroke: "#0284C7",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16L14 22",
    stroke: "#0284C7",
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg10D);
export default __webpack_public_path__ + "static/media/10d.caa03826cf952104aab529115157b87c.svg";
export { ForwardRef as ReactComponent };